<p-dialog
        [(visible)]="visible"
        [modal]="true"
        header="Assign samples to vehicle model"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '1200px' }"
        (onHide)="close()"
>
    <div class="my-2">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-search"/>
                <input pInputText id="on_label" [(ngModel)]="this.search" autocomplete="off"
                       (input)="onSearch($event)">
            </p-iconfield>
            <label for="on_label">Search original name or sales code</label>
        </p-ifta-label>
    </div>
    <div class="border border-gray-300 dark:border-gray-700 rounded-sm p-2">
        <p-table
                [value]="this.samples"
                [rows]="this.rows"
                [totalRecords]="this.totalRecords"
                [lazy]="true"
                [loading]="this.loading"
                [first]="this.page * this.rows"
                [rowsPerPageOptions]="[5, 10, 20]"
                (onLazyLoad)="loadSamples($event)"
                [paginator]="true"
                [selection]="selectedSamples"
                (selectionChange)="onSelectionChange($event)"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th></th>
                    <th>Printed Name
                    </th>
                    <th>
                        ES2Key
                    </th>
                    <th>Field of Use
                    </th>
                    <th>Type
                    </th>
                    <th>Category
                    </th>
                    <th>State
                    </th>
                    <th>Last Activity
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-sample>
                <tr [pSelectableRow]="sample">
                    <td>
                        <p-tableCheckbox [value]="sample"></p-tableCheckbox>
                    </td>
                    <td><img
                            [src]="sample?.media?.content?.preview?.cloudfrontUrl || 'assets/images/no-image.png'"
                            alt="Sample Image"
                            class="w-10 h-10 object-cover rounded-sm"></td>
                    <td>
                        <div>{{ sample.printedName }}</div>
                        <div class="text-sm text-gray-500 dark:text-gray-400">
                            {{ sample.detailNames || '' }}
                        </div>
                    </td>
                    <td>{{ sample.es2Key }}</td>
                    <td>
                        <p-tag
                                [value]="sample.fieldOfUse | enumLabel"
                                [severity]="sample.fieldOfUse | fieldOfUseSeverity"
                        ></p-tag>
                    </td>
                    <td>
                        <p-tag
                                [value]="sample.type.name"
                                severity="secondary"
                        ></p-tag>
                    </td>
                    <td>
                        <p-tag
                                [value]="sample.category?.name ?? 'No category'"
                                severity="secondary"
                        ></p-tag>
                    </td>

                    <td>
                        <p-tag
                                [value]="sample.state | enumLabel"
                                [severity]="sample.state | sampleStateSeverity"
                        ></p-tag>
                    </td>
                    <td>{{ sample.lastActivity | formatDateTime }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class="mt-5 py-5 flex justify-end">
        <p-button label="Assign" icon="pi pi-plus" (click)="addSamples()"
                  [disabled]="!selectedSamples.length"></p-button>
    </div>
</p-dialog>
